import { Store, useStore } from '@data/store'
import { BuildStatusSlice } from '@data/store/slices/buildStatus'

const isNewerBuildAvailableSelector = (state: Store) => state.buildStatus.isNewerBuildAvailable
export function useIsNewerBuildAvailable(): BuildStatusSlice['isNewerBuildAvailable'] {
    return useStore(isNewerBuildAvailableSelector)
}

const activeBuildIdSelector = (state: Store) => state.buildStatus.activeBuildId
export function useActiveBuildId(): BuildStatusSlice['activeBuildId'] {
    return useStore(activeBuildIdSelector)
}

export function getActiveBuildId(): BuildStatusSlice['activeBuildId'] {
    return useStore.getState().buildStatus.activeBuildId
}

const wasLoggedSelector = (state: Store) => state.buildStatus.wasLogged
export function useHasLoggedBuildInfo(): BuildStatusSlice['wasLogged'] {
    return useStore(wasLoggedSelector)
}
